// extracted by mini-css-extract-plugin
export default {"calendarEventSmall":"SmallCalendarEvent_calendarEventSmall__0iVaW","iconText":"SmallCalendarEvent_iconText__BwMnH"};